import { render, staticRenderFns } from "./SideImg.vue?vue&type=template&id=d6213586&"
import script from "./SideImg.vue?vue&type=script&lang=js&"
export * from "./SideImg.vue?vue&type=script&lang=js&"
import style0 from "./SideImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports